// extracted by mini-css-extract-plugin
module.exports = {"Container":"style-module--Container--23-El","bottomSpace":"style-module--bottomSpace--2MPm4","Title":"style-module--Title--1KVUQ","Button":"style-module--Button--27ZrP"};